import React, { Fragment, useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import FieldWrapper from "../commons/FieldWrapper";
import { getAllApplicants, moveApplicantsToNextStage } from "./Axios";
import Swal from "sweetalert2";

const MassiveNextStageModal = ({
                                 buttonSize,
                                 courseId,
                                 workFlow,
                                 _applicantsSelected,
                                 reloadQuery,
                                 isAdmin
                               }) => {
  const [modal, setModal] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const [applicantsSelected, setApplicantsSelected] = useState(_applicantsSelected);
  const [stageSelected, setStageSelected] = useState(null);
  const [forceNextStage, setForceNextStage] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (modal) {
      setApplicantsSelected(_applicantsSelected);
      fetchApplicants();
    } else {
      setApplicantsSelected([]);
      setError(false);
    }
  }, [modal, _applicantsSelected]);

  const fetchApplicants = () => {
    getAllApplicants(courseId, response => {
      const formattedApplicants = response.data.map(applicant => ({
        value: applicant.id,
        label: applicant.full_name
      }));
      setApplicants(formattedApplicants);
    });
  };

  const toggle = () => setModal(!modal);

  const handleChangeApplicantsSelected = newValue => {
    setApplicantsSelected(newValue || []);
    setError(false);
  };

  const handleChangeStageSelected = newValue => {
    setStageSelected(newValue);
    setError(false);
  };

  const handleCheckboxChange = () => {
    setForceNextStage(prev => !prev);
  };

  const stageOptions = workFlow.map(stage => ({
    value: stage.type,
    label: stage.name
  }));

  const handleSubmit = async () => {
    if (applicantsSelected.length === 0 || !stageSelected) {
      setError(true);
      return;
    }

    Swal.fire({
      title: "Moviendo postulantes...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const postulationIds = applicantsSelected.map(applicant => applicant.value);

    moveApplicantsToNextStage(courseId, postulationIds, stageSelected.value, forceNextStage, response => {
      if (response.status !== 200) {
        Swal.fire("Error", "No se pudieron mover los candidatos de etapa.", "error");
        return;
      }

      const { data: applicants } = response;
      const total = applicants.length;
      const errors = applicants.filter(applicant => applicant.errors.length > 0);
      const successful = total - errors.length;

      const formatErrors = errors
        .map(({ applicant_name, errors }) => {
          const formattedErrors = errors.map(error => error.replace(/^Enrollment\s*/, ""));
          return `<li class='fs-6 list-unstyled'><strong>${applicant_name}:</strong> ${formattedErrors.join(", ")}</li>`;
        })
        .join("");

      const message = `
      <p><strong>Candidatos procesados correctamente:</strong> ${successful}/${total}</p>
      ${errors.length > 0 ? `<p><strong>Candidatos que no pudieron cambiar de etapa:</strong></p><ul>${formatErrors}</ul>` : ""}
    `;

      Swal.fire({
        title: "Resultado del proceso",
        html: message,
        icon: errors.length > 0 ? "warning" : "success",
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.isConfirmed) {
          reloadQuery();
        }
      });

      toggle();
    });
  };

  return (
    <Fragment>
      <Button color="secondary" size={buttonSize} outline onClick={toggle} >
        Mover a siguiente etapa
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          Mover a Siguiente Etapa
        </ModalHeader>
        <ModalBody>
          <FieldWrapper errors={error && applicantsSelected.length === 0 ? ["Debe seleccionar candidatos"] : []}>
            <Select
              isMulti
              placeholder="Seleccione Candidatos"
              options={applicants}
              onChange={handleChangeApplicantsSelected}
              value={applicantsSelected}
            />
          </FieldWrapper>
          <FieldWrapper errors={error && !stageSelected ? ["Debe seleccionar una etapa"] : []}>
            <Select
              placeholder="Seleccione Etapa"
              options={stageOptions}
              onChange={handleChangeStageSelected}
              value={stageSelected}
            />
          </FieldWrapper>
          { isAdmin && (
          <FormGroup>
            <Label check>
              <Input type="checkbox" checked={forceNextStage} onChange={handleCheckboxChange} />
              Forzar cambio de etapa (ignorar pendientes)
            </Label>
          </FormGroup>
            )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmit}>
            Confirmar
          </Button>{" "}
          <Button color="danger" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default MassiveNextStageModal;
